<template>
    <div>
        <div>
            <div class="row">
                <div class="col-md-8 col-12">
                    <h4 class="def-title">Regras de ICMS ST</h4>
                </div>
            </div>

            <div id="cabec">
                <div class="col">
                    <div class="alert alert-warning fade show" role="alert" v-if="showHint">
                        <button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>
                        <small>Preencha os campos abaixo para prosseguir com a configuração das regras do icms por subtituição tributária</small>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-3 col-6">
                        <div class="form-group">
                            <v-label :metadata-field="metadata.regrast.ufori"></v-label>
                            <select2 v-model="lUfori" name="ufori"
                                v-bind:options="{}" 
                                v-bind:value="lUfori" 
                                v-validate="{required: true}"
                                entity="estado"
                                :minlength="0"
                                :disabled="showRegras">
                            </select2>
                            <small class="error" v-if="errors.has('ufori')">{{ errors.first('ufori') }}</small>
                        </div>
                    </div>

                    <div class="col-md-3 col-6">
                        <div class="form-group">
                            <v-label :metadata-field="metadata.regrast.finalidade"></v-label>
                            <select v-validate="{required: true}" name="finalidade" v-model="lFinalidade" class="form-control form-control-sm" :disabled="showRegras">
                                <option v-for="opt in metadata.regrast.finalidade.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                            </select>
                            <small class="error" v-if="errors.has('finalidade')">{{ errors.first('finalidade') }}</small>
                        </div>
                    </div>

                    <div class="col-md-6 col-12">
                        <div class="form-group">
                            <v-label :metadata-field="metadata.regrast.ncm"></v-label>
                            <select2 v-model="lNcm" name="ncm"
                                v-bind:options="{}" 
                                v-bind:value="lNcm" 
                                v-validate="{required: true}"
                                entity="ncm"
                                :minlength="1"
                                :disabled="showRegras">
                            </select2>
                            <small class="error" v-if="errors.has('ncm')">{{ errors.first('ncm') }}</small>
                        </div>
                    </div>

                </div>                

                <div class="col">
                    <div class="alert alert-danger fade show" role="alert" v-if="showError">
                        <button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>
                        <small>Por favor preencha os campos antes de continuar</small>
                    </div>
                </div>
                <div class="row" v-if="!showRegras">
                    <br>
                    <div class="col-md-4 col-6">
                        <div class="btn-group">
                            <a href="javascript:void(0);" 
                                class="btn btn-sm btn-outline-secondary"   
                                style="margin-right: 5px" 
                                @click="closeForm()"><i class="fa fa-arrow-left" aria-hidden="true"> Voltar</i></a>
                        </div>
                        <div class="btn-group" v-show="!showRegras">
                            <a href="javascript:void(0);" 
                                class="btn btn-sm nb-btdef" 
                                style="margin-right: 5px" 
                                @click="handleContinuar()"><i class="fa fa-arrow-right" aria-hidden="true"></i> Continuar</a>
                        </div>
                    </div>
                </div>

            </div>     <!-- cabec -->
            <div id="regras" v-if="showRegras">
                <!-- botoes -->
                <div class="row">
                    <div class="col-md-4 col-6">
                        <div class="btn-group">
                            <a href="javascript:void(0);" 
                                class="btn btn-sm btn-outline-secondary"   
                                style="margin-right: 5px" 
                                @click="handleDescartar()"><i class="fa fa-arrow-left" aria-hidden="true"> Descartar</i></a>
                        </div>
                        <div class="btn-group" v-show="showRegras">
                            <a href="javascript:void(0);" 
                                class="btn btn-sm nb-btdef" 
                                style="margin-right: 5px" 
                                @click="validate()"><i class="fa fa-arrow-right" aria-hidden="true"></i> Salvar</a>
                        </div>
                    </div>
                </div>
                <br>

                <!-- Lista de regras -->
                <div>
                    <div class="mainbox" v-for="(regrast, index) in regrastList" v-bind:key="index">
                        <div v-bind:class="[{ 'mark-red': (regrast.stregrast === 'I') }, { 'mark-green': (regrast.stregrast === 'A') }]"></div>
                        <div class="row">
                            <div class="col-md-2 col-2">
                                <span class="lbl-title">Estado: {{ regrast.ufdest }} </span>
                            </div>
                        </div>
                        <div class="box">
                            <div class="row">
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.mva"></v-label>
                                        <input-value class="form-control form-control-sm" 
                                            v-model="regrast.mva" v-bind:precision="2"></input-value>
                                    </div>
                                </div>
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.aicmst"></v-label>
                                        <input-value class="form-control form-control-sm" 
                                            v-model="regrast.aicmst" v-bind:precision="2"></input-value>
                                    </div>
                                </div>
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.pautaicmst"></v-label>
                                        <input-value class="form-control form-control-sm" 
                                            v-model="regrast.pautaicmst" v-bind:precision="2"></input-value>
                                    </div>
                                </div>
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.ricmst"></v-label>
                                        <input-value class="form-control form-control-sm" 
                                            v-model="regrast.ricmst" v-bind:precision="2"></input-value>
                                    </div>
                                </div>
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.dtinicio"></v-label>
                                        <input type="date" class="form-control form-control-sm" v-model="regrast.dtinicio">
                                    </div>
                                </div>
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.optsimples"></v-label>
                                        <select v-model="regrast.optsimples" class="form-control form-control-sm">
                                            <option v-for="opt in metadata.regrast.optsimples.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                                        </select>
                                    </div>
                                    <!-- <input-checkbox v-model="regrast.optsimples" value-checked="S" value-unchecked="N" :metadata-field="metadata.regrast.optsimples"></input-checkbox> -->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-2 col-2">
                                    <div class="form-group">
                                        <v-label :metadata-field="metadata.regrast.stregrast"></v-label>
                                        <select v-model="regrast.stregrast" class="form-control form-control-sm">
                                            <option v-for="opt in metadata.regrast.stregrast.options" :key="opt.id" :value="opt.id">{{ opt.text }}</option>
                                        </select>
                                    </div>
                                    <!-- <input-checkbox v-model="regrast.stregrast" value-checked="A" value-unchecked="I" :metadata-field="metadata.regrast.stregrast"></input-checkbox> -->
                                </div>
                            </div>
                            <div class="col" v-if="regrast.validate">
                                <small class="error"> {{ regrast.validate }} </small>
                            </div>
                        </div>
                    </div>    <!-- mainbox -->
                </div>
                
            </div>     <!-- items -->


        </div>

        <vue-snotify></vue-snotify>

        <md-message v-if="showMessage" :code="codeMessage"
            @close="closeMessage()" @confirm="handleConfirmMessage()">
        </md-message>

    </div>
</template>

<script>

/*
- falta incluir mais ncms
- obrigatorio informar mva, %icms st, vlr pauta
- % icms fcp
- importar tabela de ncms
- lista de regras (estado origem, finalidade, ncm)

*/

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        crud: '',
        ufori: '',
        finalidade: '',
        ncm: '',
    },

    data() {
        return {
            crudText: '',

            metadata: this.$store.getters.getEntities.metadata,
            regrast: {...this.$store.getters.getEntities.regrast},

            lFinalidade: '',
            lUfori: '',
            lNcm: '',

            regrastList: [],
            estadoList: [],

            showMessage: false,
            message: '',
            showHint: true,
            showRegras: false,
            showError: false,
        }
    },

    computed: {
    },

    watch: {
    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleCloseForm() {
            if (this.changed) {                     // se ocorreu alguma alteração exibe mensagem antes de fechar
                this.showMessageModal('closeform')
            } else {
                this.closeForm()
            }
        },

        handleDescartar () {
            this.showRegras = false
            this.regrastList = []
        },

        handleConfirmMessage () {
            //EVENTO DO BOTAO "CONFIRMAR" DA MENSAGEM
            if (this.codeMessage == 'closeform') { //fecha o formulario e retornar para o anterior
              this.closeMessage()
              this.closeForm()
            }
        },

        showMessageModal (code) {
            //exibe uma mensagem em "code"
            this.codeMessage = code
            this.showMessage = true
        },

        closeMessage () {
            this.showMessage = false
        },

        validate () {
            let lErro = false
            let validate = ''

            for (var x = 0; x < this.regrastList.length; x++) {
                validate = ''
                if (this.regrastList[x].mva > 99) {
                    validate = 'O valor informado para o MVA é inválido'
                } else
                if (this.regrastList[x].aicmst > 99) {
                    validate = 'O valor informado para o % ICMS é inválido'
                } else
                if (this.regrastList[x].ricmst > 99) {
                    validate = 'O valor informado para a Red ICMS é inválido'
                } else
                if (this.regrastList[x].aicmst > 0) {
                    if (this.regrastList[x].mva == null || this.regrastList[x].mva == 0) {
                        if (this.regrastList[x].pautaicmst == null || this.regrastList[x].pautaicmst == 0) {
                            validate = 'Obrigatório informar MVA ou valor de pauta'
                        }
                    }
                }
                if (validate.length > 0) {
                    lErro = true
                    this.$set(this.regrastList[x], 'validate', validate)
                } else {
                    this.$set(this.regrastList[x], 'validate', '')
                }
            }

            if (lErro) {
                this.$erpToastError('Por favor corrija os erros para continuar.')
            } else {
                this.apiPost()
            }
        },

        async loadEstados () {
            //carrega uma lista de estados
            await this.$store.dispatch('loadEstadoRegras')
            if (this.$store.getters.getEstadoList) {
                this.estadoList = this.$store.getters.getEstadoList
            }
        },

        handleContinuar() {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.showError = true
                } else {
                    this.showError = false
                    this.loadRegra()
                }
            })
        },

        async loadRegra () {
            //carrega a lista de regras relacionadas ao estado de origem, finalidade e ncm informados.
            //para facilitar o preenchimento, a lista é carregada com os estados de destino mesmo que nao exista regras cadastradas.
            let params = { path: this.lUfori + '/' + this.lFinalidade + '/' + this.lNcm }
            await this.$store.dispatch('loadRegrast', params)
            if (this.$store.getters.getRegrast && this.$store.getters.getRegrast.length > 0) {
                this.regrastList = this.$store.getters.getRegrast
            } else {
                this.regrastList = []
                for (var x = 0; x < this.estadoList.length; x++) {
                    let regrast = {...this.regrast}
                    regrast.ufdest = this.estadoList[x].uf
                    regrast.ufori = this.lUfori
                    regrast.finalidade = this.lFinalidade
                    regrast.ncm = this.lNcm
                    regrast.optsimples = 'S'
                    regrast.stregrast = 'A'
                    this.regrastList.push(regrast)
                }
            }
            this.showHint = false
            this.showRegras = true
        },

        async apiDelete (del) {
            //efetua a exclusao do participante

            var modulo = 'cg/regrast/' + this.part.codpart
            var sendData = {}

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastSuccess('A Regra foi excluída.')
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao das regras

            var modulo = 'cg/regrast/'
            var sendData = {}

            //this.part.partcontato = this.partcontato
            sendData = { regrast: this.regrastList }

            var metodo = 'post'

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            this.$erpToastSuccess('As regras foram gravadas com sucesso')
            this.showRegras = false
            if (this.crud == SysVars.crudU) {
              this.closeForm()
            }
        },

    },

    created () {
        this.loadEstados()

        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.lFinalidade = 'I'

        if (this.crud == SysVars.crudU) {
        //if (this.ufori && this.finalidade && this.ncm) {
            this.showHint = false
            this.lUfori = this.ufori
            this.lFinalidade = this.finalidade
            this.lNcm = this.ncm
            this.loadRegra()
        }

    }

}

</script>

<style>

</style>


// WEBPACK FOOTER //
// src/forms/regrast-form.vue